export const HOME_MODULE = 'HOME_MODULE'
export const COLLEGE_MODULE = 'COLLEGE_MODULE'
export const DOC_MODULE = 'DOC_MODULE'
export const PROFILE_MODULE = 'PROFILE_MODULE'